import { defineStore } from 'pinia';
import { useStore } from '@/js/stores';
import {login, logout, register} from "@/js/service/auth";
import {unmaskPhone, isPhoneInput} from "@/js/helpers/masks";
import {getForm} from "@/js/service/studioRegisters";
import router from "@/js/router";
import {deleteCookie, writeCookie} from "@/js/utils";
import {track, ANALYTICS_EVENTS} from "@/js/analytics";

export const UserAlreadyRegisterError = 'err.already_register';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        loginForm: {
            login: '',
            password: '',
            'remember-me': true
        },
        registerForm: {
            phone: '',
            email: '',
            city: '',
            title: '',
            name: '',
            surname: ''
        },
        resetPassword: {
            login: '',
        },
        loginErrors: {},
        registerErrors: {},
        errorMessage: '',
        successLogin: false,
        successTitle: '',
        successMessage: 'Вы авторизованы',
        successCloseable: true,
        cities: [],
    }),
    actions: {
        async login() {
            const store = useStore();
            let params = new FormData();

            let loginValue = this.loginForm.login;
            if (isPhoneInput(loginValue)) {
                loginValue = unmaskPhone(loginValue);
            }

            params.append('login', loginValue);
            params.append('password', this.loginForm.password);
            try {
                await login(params);
                await this.handleSuccessfulAuth();
            } catch (error) {
                let errorCode = error?.data?.errors?.errorCode?.[0];

                if (errorCode === UserAlreadyRegisterError) {
                    store.loadingApp = true;
                    await router.replace({path: '/register'});
                    await store.getInitData();
                    store.loadingApp = false;
                }

                if (error.data.message) {
                    store.handleAlert('error', '', true, error.data.message);
                }
                if (error.data.errors) this.loginErrors = error.data.errors;
            }
        },
        async handleSuccessfulAuth() {
            const store = useStore();
            this.loginErrors = [];
            store.auth = true;
            writeCookie('auth', true, 30);
            const response = await getForm();
            store.handleAlert('success', '', true, 'Вы авторизованы', 3000);
            if (response?.data?.attributes?.step) {
                store.onboardingProgress = response.data.attributes.step;
                if (store.onboardingPassed) {
                    writeCookie('onboarding', true, 30);
                    store.loadingApp = true;
                    await router.replace({ path: '/' });
                    await store.getInitData();
                    store.loadingApp = false;
                } else {
                    writeCookie('onboarding', false, 30);
                    store.loadingApp = true;
                    await router.replace({ path: '/onboarding' });
                    await store.getInitData();
                    store.loadingApp = false;
                }
            } else {
                await router.replace({ path: '/' });
            }
        },
        async resetPassword() {
            //
        },
        async logout() {
            const store = useStore();
            store.loadingApp = true;
            try {
                await logout();
                store.auth = false;
                writeCookie('auth', false, 30);
                deleteCookie('onboarding');
                deleteCookie('bearer_token');
                router.go();
            } catch (error) {
                store.loadingApp = false;
            }
        },
        async handleRegister() {
            const store = useStore();
            let params = new FormData();
            Object.keys(this.registerForm).forEach(key => {
                params.append(key, this.registerForm[key]);
            });
            try {
                await register(params);
                await this.handleSuccessfulRegister();
            } catch (error) {
                if (error.data.message) {
                    store.handleAlert('error', '', true, error.data.message, 3000);
                }
                if (error.data.errors) this.registerErrors = error.data.errors;
            }
        },
        async handleSuccessfulRegister() {
            const store = useStore();
            this.registerErrors = [];
            store.auth = true;
            writeCookie('auth', true, 30);
            writeCookie('onboarding', false, 30);
            store.handleAlert('success', '', true, 'Вы зарегистрированы', 3000);
            track(ANALYTICS_EVENTS.ONBOARDING_REGISTRATION_SUBMITTED);
            store.loadingApp = true;
            await router.replace({ path: '/onboarding' });
            await store.getInitData();
            store.loadingApp = false;
        },
    }
})
